import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonForTask = ({ count = 3 }) => {
    return (
        <>
            {Array.from({ length: count }).map((_, idx) => (
                <div key={idx} className="mx-3 my-3 max-h-[150px] rounded-lg dark:bg-[rgba(255,255,255,0.05)] shadow-sm border border-border-primary  p-[10px] flex flex-col justify-between last:mb-3">
                    {/* Left */}
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <div className="flex items-center">
                                <Skeleton width={20} height={20} className="rounded" />
                            </div>

                            <h3 className="text-[16px] font-normal text-text-headings dark:text-white ml-2">
                                <Skeleton width={200} height={16} />
                            </h3>

                            <div className="ml-auto">
                                <Skeleton width={24} height={24} className="rounded" />
                            </div>
                        </div>

                        <div className="pl-4">
                            <Skeleton width={140} height={12} />
                            <div className="mt-1">
                                <Skeleton width={120} height={12} />
                            </div>
                        </div>
                    </div>


                    {/* Right */}
                    <div className="flex items-center justify-between mt-[20px] h-full">
                        <div className={`text-[14px] pr-2 rounded-full font-medium`}>
                            <Skeleton width={140} height={18} />
                        </div>
                        <div className="flex items-center">
                            <Skeleton width={22} height={22} className="rounded" />
                        </div>

                    </div>
                </div>
            ))}
        </>
    );
};

export default SkeletonForTask;